import {
  CpsFieldForView,
  CpsFieldRequest,
  CpsGridView,
  DEFAULT_FACETS_COUNT,
  EditingViewState,
  UpdateViewRequest
} from '@cs-cms/types';

const sortAlphabetically = (a: { name: string }, b: { name: string }): number => a.name.localeCompare(b.name);

export const getSortedViews = (views: CpsGridView[]): CpsGridView[] => {
  if (views.length === 0) {
    return [];
  }

  return [
    ...views.filter(view => !view.isPrivate).sort(sortAlphabetically),
    ...views.filter(view => view.isPrivate).sort(sortAlphabetically)
  ];
};

export const transformFieldsForCreation = (fields: CpsFieldForView[]): CpsFieldForView[] => {
  return fields.map(field => ({
    ...field,
    facetsCount: field.facetable ? DEFAULT_FACETS_COUNT : field.facetsCount || 0
  }));
};

export const buildUpdateViewRequest = (
  viewId: number,
  viewName: string,
  editingViewState: EditingViewState
): UpdateViewRequest => {
  const fields = editingViewState.fields.map(
    field =>
      ({
        id: field.id,
        width: field.width,
        freezed: false,
        facetsCount: field.facetable ? (field.facetsCount ?? DEFAULT_FACETS_COUNT) : null,
        facetable: field.facetable ?? false,
        isDocumentLink: field.isDocumentLink
      }) as CpsFieldRequest
  );

  return {
    viewId,
    name: viewName,
    fields,
    globalFilters: editingViewState.globalFilters.map(filter => ({
      fieldId: filter.id,
      facetsCount: filter.facetsCount
    }))
  };
};

export const findViewById = (views: CpsGridView[], viewId: number | null | undefined): CpsGridView | undefined => {
  if (viewId == null) {
    return undefined;
  }

  return views.find(view => view.id === viewId);
};

export const getDefaultViewIdAfterDelete = (views: CpsGridView[], deletedViewId: number): number => {
  const defaultView = views.find(view => view.isDefault && view.id !== deletedViewId);
  return defaultView ? defaultView.id : views[0].id;
};

export const resolveInitialSelectedViewId = (
  views: CpsGridView[],
  selectedView: number | null | undefined
): number | undefined => {
  if (views.length === 0) {
    return undefined;
  }

  const isSelectedViewAvailable = selectedView != null && views.some(view => view.id === selectedView);

  if (selectedView && isSelectedViewAvailable) {
    return undefined;
  }

  const defaultView = views.find(view => view.isDefault);
  return defaultView ? defaultView.id : views[0].id;
};
